import { WithBookablePeriod } from '@mews-commander/types';
import { lt } from '@mews/framework';
import { LocalizedBookablePeriodWithProducts } from './LocalizedBookablePeriodWithProducts';
import { LocalizedCancellationPolicyBookablePeriod } from './LocalizedCancellationPolicyBookablePeriod';

interface Props extends WithBookablePeriod {
    feeExtent: Array<'TimeUnits' | 'Products'>;
}

export const FeeExtent = ({ feeExtent, bookablePeriod }: Props) => {
    if (feeExtent.includes('TimeUnits') && feeExtent.includes('Products')) {
        return <LocalizedBookablePeriodWithProducts bookablePeriod={bookablePeriod} />;
    }

    if (feeExtent.includes('TimeUnits')) {
        return <LocalizedCancellationPolicyBookablePeriod bookablePeriod={bookablePeriod} />;
    }

    if (feeExtent.includes('Products')) {
        return lt('CancellationFeeExtentProducts');
    }

    return null;
};
